<style type="text/css">
.body {
  width: 100%;
  margin: auto;
  padding: auto;
  height: 100%;
  
}

.main {
  width: 48%;
  padding-top: 10px;
  height: 400px;
  position: relative;
  float: left;
  margin: auto;
}

.main1 {
  width: 48%;
  padding-top: 10px;
  height: 400px;
  position: relative;
  float: right;
  margin: auto;
}
.main2 {
  padding-top: 10px;
  width: 48%;
  height: 400px;
  float: right;
  position: relative;
  margin: auto;
}
.main3 {
  padding-top: 10px;
  width: 48%;
  height: 400px;
  float: left;
  position: relative;
  margin: auto;
}
</style>
<template>
  <div>
    <div class="main" id="main">
    </div>
    <div class="main1" id="main1">
    </div>
    <div class="main2" id="main2" v-if="this.BodyId!=114">
    </div>
    <div class="main3" id="main3" v-if="this.BodyId!=114">
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts5';
export default {
  name: "Home",
  data() {
    return {
      height:"400px",
      BodyId:"",
      chartDom: "",
      myChart: "",
      option: "",
      chartDom1: "",
      myChart1: "",
      option1: "",
      chartDom2: "",
      myChart2: "",
      option2: "",
      data: [],
      data1: [],
      data2: [],
      data3: [],
    };
  },
  mounted() {
  
  },
  created() {
    this.getHomeDataLine();
    this.getHomeValveData();
    this.getHomeAlarmData();
    this.getHomeBoxData();
    var that = this;
    if (localStorage.getItem("isAdmin") != "true") {
    that.BodyId= localStorage.getItem("personnelGroverningBodyId");
    }
  },
  methods: {
    getHomeDataLine() {
      $.ajax({
        url:
          "/api/alarm/admin/Home/getBodyId?BodyId=" + localStorage.getItem("personnelGroverningBodyId"),
        contentType: "application/json",
        type: "post",
        dataType: "json",
        success: function(result) {
          var myChart1 = echarts.init(document.getElementById('main1'));
          var option1 = {
          title: {
            text: '设备在线率'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {},
          toolbox: {
            show: true,
            feature: {
              magicType: { type: ['line', 'bar'] },
              restore: {},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data:result.data.dateSet,
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value} 台'
            }
          },
          series: [
            {
              name: '安全阀',
              type: 'line',
              data: result.data.Valve,
            },
            {
              name: '报警器',
              type: 'line',
              data: result.data.Alarm,
            },
            {
              name: '智能盒',
              type: 'line',
              data: result.data.Box,
            }
          ]
        }
          myChart1.setOption(option1);
      },
        error: function (textStatus) {
          $Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    getHomeAlarmData() {
      $.ajax({
        url:
          "/api/alarm/admin/Home/getHomeAlarmData?BodyId=" + localStorage.getItem("personnelGroverningBodyId"),
        contentType: "application/json",
        type: "post",
        dataType: "json",
        success: function(result) {
          var myChart2 = echarts.init(document.getElementById('main2'));
          var option2 = {
            title: {
            text: '安全阀报警统计',
            left: 'left'
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {},
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'value'
            },
            yAxis: {
              type: 'category',
              data: result.list
            },
            series: [
              {
                name: '报警触发',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                data: result.listErrorTrig
              },
              {
                name: '报警解除',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                data: result.listErrorClear
              }
            ]
        };
          myChart2.setOption(option2);
      },
        error: function (textStatus) {
            $Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    getHomeValveData() {
      $.ajax({
        url:
          "/api/alarm/admin/Home/getHomeValveData?BodyId=" + localStorage.getItem("personnelGroverningBodyId"),
        contentType: "application/json",
        type: "post",
        dataType: "json",
        success: function(result) {
          var myChart = echarts.init(document.getElementById('main'));
      var option = {
        title: {
            text: '报警器报警统计',
            left: 'left'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
              }
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {}
              }
            },
            legend: {},
            xAxis: {
              type: 'value'
            },
            yAxis: {
              type: 'category',
              data: result.list
            },
            series: [
              {
                name: '报警触发',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                data: result.listErrorTrig
              },
              {
                name: '报警解除',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                data: result.listErrorClear
              }
            ]
          };
          myChart.setOption(option);
      },
        error: function (textStatus) {
            $Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    getHomeBoxData() {
      $.ajax({
        url:
        "/api/alarm/admin/Home/getHomeBoxData?BodyId=" + localStorage.getItem("personnelGroverningBodyId"),
        contentType: "application/json",
        type: "post",
        dataType: "json",
        success: function(result) {
          var myChart3 = echarts.init(document.getElementById('main3'));
      var option3 = {
        title: {
            text: '智能盒报警统计',
            left: 'left'
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {},
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'value'
            },
            yAxis: {
              type: 'category',
              data: result.list
            },
            series: [
              {
                name: '报警触发',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                data: result.listErrorTrig
              },
              {
                name: '报警解除',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                data: result.listErrorClear
              }
            ]
          };
          myChart3.setOption(option3);
      },
        error: function (textStatus) {
            $Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
  },
};
</script>